const DEFAULT_API_BASE_URL = "https://hip3-term-backend-production.up.railway.app";
// const DEFAULT_API_BASE_URL = "http://localhost:8080";
const DEFAULT_RETRIES = 2;
const DEFAULT_RETRY_DELAY_MS = 1_500;
const DEFAULT_TIMEOUT_MS = 30_000;

function trimTrailingSlash(value: string): string {
  return value.endsWith("/") ? value.slice(0, -1) : value;
}

function stripWrappingQuotes(value: string): string {
  if (
    (value.startsWith("\"") && value.endsWith("\"")) ||
    (value.startsWith("'") && value.endsWith("'"))
  ) {
    return value.slice(1, -1);
  }
  return value;
}

function sanitizeApiBaseUrl(value: string | undefined): string | null {
  if (!value) return null;

  const normalized = trimTrailingSlash(stripWrappingQuotes(value.trim()));
  if (!normalized) return null;

  try {
    const parsed = new URL(normalized);
    if (!parsed.protocol || !parsed.host) return null;
    return trimTrailingSlash(parsed.toString());
  } catch {
    return null;
  }
}

type Hip3Env = {
  VITE_HIP3_API_BASE_URL?: string;
};

const bunEnv = (
  globalThis as unknown as {
    Bun?: {
      env?: Hip3Env;
    };
  }
).Bun?.env;

const importMetaEnv = (import.meta as unknown as { env?: Hip3Env }).env;

const envApiBaseUrl = bunEnv?.VITE_HIP3_API_BASE_URL ?? importMetaEnv?.VITE_HIP3_API_BASE_URL;

const apiBaseUrl = sanitizeApiBaseUrl(envApiBaseUrl) ?? DEFAULT_API_BASE_URL;

export const hip3Config = {
  apiBaseUrl,
  retries: DEFAULT_RETRIES,
  retryDelayMs: DEFAULT_RETRY_DELAY_MS,
  timeoutMs: DEFAULT_TIMEOUT_MS,
};
